export const OPEN_CHAT_WINDOW = 'OPEN_CHAT_WINDOW';
export const CLOSE_CHAT_WINDOW = 'CLOSE_CHAT_WINDOW';
